@if (pageLoading && showPageLoader) {
  <app-loading-element></app-loading-element>
} @else {
  <div [ngClass]="theme.getThemeClass()" class="container-fluid">
    <!-- Side nav -->

    <!-- Menu items -->
    <nav class="nav view-tabs">
      <nav
        (click)="navigate(1)"
        id="client"
        [ngClass]="{ active: activeTab === 'client' }"
        class="nav-item nav-link"
      >
        <span class="nav-item-text">{{ 'clientList' | translate }}</span>
        <i class="fa-solid fa-users-line icon"></i>
      </nav>
      <nav
        (click)="navigate(2)"
        id="iot"
        [ngClass]="{ active: activeTab === 'device' }"
        class="nav-item nav-link"
      >
      <span class="nav-item-text">{{ 'userlistTableHeaderDeviceList' | translate }}</span>
        <i class="fa-solid fa-tachograph-digital icon"></i>
      </nav>
      <nav
        (click)="navigate(4)"
        id="zones"
        [ngClass]="{ active: activeTab === 'zones' }"
        class="nav-item nav-link"
      >
        <span class="nav-item-text">{{ 'Zones' | translate }}</span>
        <i class="fa-solid fa-map-location-dot icon"></i>
      </nav>
      <nav
        (click)="navigate(3)"
        id="routes"
        [ngClass]="{ active: activeTab === 'routes' }"
        class="nav-item nav-link"
      >
        <span class="nav-item-text">{{ "Routes" | translate }}</span>
        <i class="fa-solid fa-route icon"></i>
      </nav>
    </nav>

    <!-- Section container -->
    <div class="section-container" [hidden]="!tabsReady">
      <!-- Client list section -->
      <div id="clients" class="tab" [hidden]="!isClientsTabOpen">
        <div class="toTop">
          <a (click)="scrollToTop()"
            ><i class="fa-solid fa-circle-arrow-up"></i
          ></a>
        </div>
        <section
          [ngClass]="theme.getThemeClass()"
          class="table-container width100"
        >
          <article id="clientTop" class="table-responsive minMarginBotton">
            <header [ngClass]="theme.getThemeClass()" class="table-header">
              <h2 class="mobile">
                {{ "clientList" | translate }} ({{ this.clientArray.length }})
              </h2>
            </header>

            <header id="search-component" class="input-group">
              <input
                #searchBox
                type="search"
                id="search-box"
                [(ngModel)]="clientSearch"
                (input)="search()"
                class="form-control rounded"
                placeholder="{{ 'userlistSearchInputPlaceHolder' | translate }}"
                aria-label="Search"
                aria-describedby="search-addon"
              />
            </header>
            <nav id="search-component" class="nav-sort-filter">
              <select
                class="form-control sort-by-select"
                [(ngModel)]="this.filterBy"
                (change)="onFilterByChange()"
                [ngClass]="{ 'has-value': this.filterBy }"
              >
                <option value="">{{ "filterBy" | translate }}</option>
                @for (option of clientFilterOptions; track option.value) {
                  <option [value]="option.value">
                    {{ option.label | translate }}
                  </option>
                }
              </select>

              <select
                class="form-control sort-by-select"
                [(ngModel)]="this.sortBy"
                (change)="onSortChange('select', $event)"
                [ngClass]="{ 'has-value': this.sortBy }"
              >
                <option value="">{{ "sortBy" | translate }}</option>
                @for (option of clientSortOptions; track option.value) {
                  <option [value]="option.value">
                    {{ option.label | translate }}
                  </option>
                }
              </select>
              <div class="card-title mt-0 status">
                <label class="switch">
                  <input
                    type="checkbox"
                    [ngModel]="this.ascDesc"
                    (change)="onSortChange('switch', $event)"
                  />
                  <span class="slider round">
                    <span class="toggle-switch-label-off">{{
                      "asc" | translate
                    }}</span>
                    <span class="toggle-switch-label-on">{{
                      "desc" | translate
                    }}</span>
                  </span>
                </label>

                @if (hasCheckedClient() && !this.showingAssociations) {
                  <div style="width: 128px; height: 38px">
                    <button
                      [ngClass]="theme.getThemeClass()"
                      class="btn btn-dropdown"
                      (click)="associateClients()"
                    >
                      {{ "dispatchAssociate" | translate }}
                    </button>
                  </div>
                }
                @if (hasAssociatedClient()) {
                  <div style="width: 128px; height: 38px">
                    <button
                      [ngClass]="theme.getThemeClass()"
                      class="btn btn-dropdown"
                      (click)="dissociateClients()"
                    >
                      {{ "dispatchDissociate" | translate }}
                    </button>
                  </div>
                }
              </div>
            </nav>
            <div class="grid-container">
              <section
                [ngClass]="theme.getThemeClass(true)"
                class="gridster"
                id="clientGridster"
                [ngStyle]="getColumnStyle()"
                style="height: 100%"
              >
                @for (
                  item of clientArray;
                  let i = $index;
                  track item.client_id
                ) {
                  <article
                    class="gridster-item"
                    [ngClass]="item.checked ? 'selected' : ''"
                  >
                    <nav
                      [ngClass]="theme.getThemeClass(true)"
                      class="dashboard-tile"
                    >
                      <header
                        class="dashboard-tile-header"
                        (click)="select(item)"
                      >
                        <h6 class="dashboard-tile-title">
                          <i class="fa fa-user"></i>
                          <label>{{ item.client_name }}</label>
                        </h6>
                      </header>
                      <hr />
                      <div class="tiles-container">
                        <div
                          class="titles-items ellipsis-container"
                          (click)="displayAddress(i)"
                          style="cursor: pointer"
                        >
                          <span class="i"
                            ><i class="fa-solid fa-location-dot pointer"></i
                          ></span>
                          @if (item.address) {
                            <label
                              style="cursor: pointer"
                              id="{{ i }}"
                              class="address"
                              >{{ item.address }}</label
                            >
                          } @else {
                            <ng-template
                              [ngTemplateOutlet]="noneApplicable"
                            ></ng-template>
                          }
                        </div>
                        <div class="titles-items">
                          <i class="fa-solid fa-phone"></i>
                          @if (item.phone_number) {
                            <label>{{ item.phone_number }}</label>
                          } @else {
                            <ng-template
                              [ngTemplateOutlet]="noneApplicable"
                            ></ng-template>
                          }
                        </div>
                        <div class="titles-items">
                          <i class="fa-solid fa-at"></i>
                          <label>{{ item.email }}</label>
                        </div>
                        <div class="titles-items">
                          <i class="fa-solid fa-tachograph-digital"></i>
                          <label>{{ getDevices(item.client_id) }}</label>
                        </div>
                      </div>
                    </nav>
                  </article>
                }
              </section>
            </div>
          </article>
        </section>
      </div>

      @if (isDevicesTabOpen) {
        <div [ngClass]="theme.getThemeClass()" id="devices" class="tab">
          <div class="toTop">
            <a (click)="scrollToTop()"
              ><i class="fa-solid fa-circle-arrow-up"></i
            ></a>
          </div>

          <section
            [ngClass]="theme.getThemeClass()"
            class="table-container width100"
          >
            <article id="deviceTop" class="table-responsive minMarginBotton">
              <header [ngClass]="theme.getThemeClass()" class="table-header">
                <h2 class="mobile">
                  {{ "userlistTableHeaderDeviceList" | translate }} ({{
                    this.allThings.length
                  }})
                </h2>
              </header>

              <header id="search-component" class="input-group">
                <input
                  #searchBox
                  type="search"
                  id="search-box"
                  [(ngModel)]="deviceSearch"
                  (input)="search(1)"
                  class="form-control rounded"
                  placeholder="{{
                    'userlistSearchInputPlaceHolder' | translate
                  }}"
                  aria-label="Search"
                  aria-describedby="search-addon"
                />
              </header>
              <nav id="search-component" class="nav-sort-filter">
                <select
                  class="form-control sort-by-select"
                  [(ngModel)]="selectedClientId"
                  (change)="filterDevicesByClient()"
                  [ngClass]="{ 'has-value': this.selectedClientId }"
                >
                  <option value="">{{ "_client" | translate }}</option>
                  @for (client of allClients; track client.client_id) {
                    <option [value]="client.client_id">
                      {{ client.legal_name || client.client_name }}
                    </option>
                  }
                </select>

                <select
                  class="form-control sort-by-select"
                  [(ngModel)]="sortDeviceBy"
                  (change)="onSortDeviceChange('select', $event)"
                  [ngClass]="{ 'has-value': this.sortDeviceBy }"
                >
                  <option value="">{{ "sortBy" | translate }}</option>
                  @for (option of deviceSortOptions; track option.value) {
                    <option [value]="option.value">
                      {{ option.label | translate }}
                    </option>
                  }
                </select>

                <div class="card-title mt-0 status">
                  <label class="switch">
                    <input
                      type="checkbox"
                      [ngModel]="this.ascDesc"
                      (change)="onSortDeviceChange('switch', $event)"
                    />
                    <span class="slider round">
                      <span class="toggle-switch-label-off">{{
                        "asc" | translate
                      }}</span>
                      <span class="toggle-switch-label-on">{{
                        "desc" | translate
                      }}</span>
                    </span>
                  </label>
                  @if (hasCheckedClient()) {
                    <div style="width: 128px; height: 38px">
                      <button
                        [ngClass]="theme.getThemeClass()"
                        class="btn btn-dropdown"
                        (click)="associateClients()"
                      >
                        {{ "dispatchAssociate" | translate }}
                      </button>
                    </div>
                  }
                </div>
              </nav>
              <div class="grid-container device-grid-container">
                <section
                  [ngClass]="theme.getThemeClass(true)"
                  class="device-card-grid"
                  id="thingsGridster"
                  style="height: 100%"
                >
                  @for (
                    thing of allThings;
                    let i = $index;
                    track thing.thing_name
                  ) {
                    <article class="device-card-item">
                      <nav
                        [ngClass]="theme.getThemeClass()"
                        class="dashboardThing-tile"
                      >
                        <header class="dashboard-tile-header">
                          <div
                            class="mouseover-div"
                            (mouseenter)="this.showStateInfo[i] = true"
                            (mouseleave)="this.showStateInfo[i] = false"
                            (touchstart)="showStateInfo[i] = true"
                            (touchend)="showStateInfo[i] = false"
                          >
                            <div class="trafic-light-box">
                              <div class="traffic-light">
                                <div
                                  class="light"
                                  [ngClass]="{
                                    'light-green':
                                      thing.heartbeat &&
                                      thing.heartbeat.color === 'green',
                                    'light-yellow':
                                      thing.heartbeat &&
                                      thing.heartbeat.color === 'yellow',
                                    'light-red':
                                      thing.heartbeat &&
                                      thing.heartbeat.color === 'red',
                                  }"
                                ></div>
                              </div>
                            </div>
                            <h6 class="dashboardThing-tile-title">
                              {{ thing.thing_name | translate }}
                            </h6>

                            @if (showStateInfo[i]) {
                              <div
                                class="info-state-box"
                                [ngClass]="theme.getThemeClass()"
                              >
                                <div class="state-info-layer">
                                  <label class="state-title">
                                    {{ "beatMiss" | translate }} :
                                  </label>
                                  <label class="state-info">
                                    @if (
                                      this.iotService.isBeatMissMoreThenOneHundred(
                                        thing.heartbeat?.beat_miss
                                      )
                                    ) {
                                      <span>+</span>
                                    }
                                    {{ thing.heartbeat.beat_miss }}
                                  </label>
                                </div>
                                <div class="state-info-layer">
                                  <label class="state-title">
                                    {{ "suposeToCommunicate" | translate }} :
                                  </label>
                                  <label class="state-info">
                                    {{
                                      thing.heartbeat.supposed_to_communicate
                                    }}
                                  </label>
                                </div>
                                <div class="state-info-layer">
                                  <label class="state-title">
                                    {{ "sleepTimeConfig" | translate }} :
                                  </label>
                                  <label class="state-info">
                                    {{
                                      this.iotService.convertSecondToHour(
                                        thing.sleep_time
                                      ) | translate
                                    }}
                                  </label>
                                </div>
                              </div>
                            }
                          </div>

                          @if (thing.battery > 100) {
                            <i class="fa-solid fa-plug-circle-bolt"></i>
                          }
                          <span class="dashboard-tile-action-container">
                            <!-- Keeping this here for future use if we give collectors more options -->
                            <!-- <a
                              class="nav-link e"
                              href="javascript:void(0);"
                              data-bs-toggle="dropdown"
                            >
                              <i class="fa fa-bars"></i>
                            </a> -->
                            <ul
                              [ngClass]="theme.getThemeClass()"
                              class="dropdown-menu dropdown-menu-lg-end"
                            >
                              <li>
                                <a
                                  [ngClass]="theme.getThemeClass()"
                                  class="dropdown-item"
                                  style="cursor: pointer"
                                  (click)="setNavToDeviceStat(thing.thing_name)"
                                >
                                  <i
                                    class="textAlignCenter"
                                    [ngClass]="thing.icon"
                                  ></i>
                                  <span class="customMarginLeft1">
                                    {{ "deviceStatistics" | translate }}
                                  </span>
                                </a>
                              </li>
                            </ul>
                          </span>
                        </header>
                        <hr />
                        <div
                          [ngClass]="theme.getThemeClass()"
                          class="dashboardThing-tile-content"
                        >
                          <div class="marketLabel">
                            {{ thing.device?.bin.bin_usage | translate }}
                            {{ thing.device.bin.market_segment | translate }}
                          </div>
                          <div class="itemsDisplay">
                            <div class="firstRow">
                              <div class="itemsColum">
                                <div class="fa-3x">
                                  @if (thing.status === "Healthy") {
                                    <i
                                      class="fa-solid fa-heart-pulse greenC"
                                      [title]="'Healthy'"
                                    ></i>
                                  }
                                  @if (thing.status === "Inactive") {
                                    <i
                                      class="fa-solid fa-heart-pulse grayC"
                                      [title]="'Inactive'"
                                    ></i>
                                  }
                                  @if (thing.status === undefined) {
                                    <i
                                      class="fa-solid fa-heart-pulse grayC"
                                      [title]="'Inactive'"
                                    ></i>
                                  }
                                  @if (thing.status === "Unhealthy") {
                                    <i
                                      class="fa-solid fa-heart-pulse fa-fade redC"
                                      [title]="'Unhealthy'"
                                    ></i>
                                  }
                                </div>
                                <div class="iconLabel">
                                  {{ thing.status | translate }}
                                </div>
                              </div>

                              <div class="itemsColum">
                                <div class="fa-3x">
                                  @if (thing.status === "Inactive") {
                                    <i
                                      class="fa-solid fa-battery-empty grayC"
                                      [title]="'Inactive'"
                                    ></i>
                                  }
                                  @if (
                                    thing.battery > 3.5 &&
                                    thing.status != "Inactive"
                                  ) {
                                    <i
                                      [ngStyle]="getBatteryLevel(thing.battery)"
                                      class="fa-solid fa-battery-full"
                                      [title]="thing.battery + '%'"
                                    ></i>
                                  }
                                  @if (
                                    thing.battery <= 3.5 &&
                                    thing.battery > 2.5 &&
                                    thing.status != "Inactive"
                                  ) {
                                    <i
                                      [ngStyle]="getBatteryLevel(thing.battery)"
                                      class="fa-solid fa-battery-three-quarters"
                                      [title]="thing.battery + '%'"
                                    ></i>
                                  }
                                  @if (
                                    thing.battery <= 2.5 &&
                                    thing.battery > 1.5 &&
                                    thing.status != "Inactive"
                                  ) {
                                    <i
                                      [ngStyle]="getBatteryLevel(thing.battery)"
                                      class="fa-solid fa-battery-half"
                                      [title]="thing.battery + 'V'"
                                    ></i>
                                  }
                                  @if (
                                    thing.battery <= 1.5 &&
                                    thing.battery > 0 &&
                                    thing.status != "Inactive"
                                  ) {
                                    <i
                                      [ngStyle]="getBatteryLevel(thing.battery)"
                                      class="fa-solid fa-battery-quarter fa-fade"
                                      [title]="thing.battery + '%'"
                                    ></i>
                                  }
                                  @if (
                                    thing.battery == 0 &&
                                    thing.status != "Inactive"
                                  ) {
                                    <i
                                      [ngStyle]="getBatteryLevel(thing.battery)"
                                      class="fa-solid fa-battery-empty fa-fade"
                                      [title]="thing.battery + '%'"
                                    ></i>
                                  }
                                  @if (
                                    thing.battery == null ||
                                    thing.battery == undefined
                                  ) {
                                    <i
                                      [ngStyle]="getBatteryLevel(thing.battery)"
                                      class="fa-solid fa-battery-empty grayC"
                                      [title]="'Inactive'"
                                    ></i>
                                  }
                                </div>
                                @if (
                                  thing.battery >= 0 &&
                                  thing.battery <= 100 &&
                                  thing.status != "Inactive"
                                ) {
                                  <div class="iconLabel">
                                    {{ thing.battery + "%" | translate }}
                                  </div>
                                }
                                @if (thing.battery > 100) {
                                  <div class="iconLabel">
                                    {{ "charging" | translate }}
                                  </div>
                                }
                                @if (thing.status === "Inactive") {
                                  <div class="iconLabel">
                                    {{ "Inactive" | translate }}
                                  </div>
                                }
                              </div>
                              <div class="itemsColum">
                                <div class="fa-3x">
                                  @if (thing.status === "Healthy") {
                                    <i
                                      [ngStyle]="
                                        getFillLevelStyle(thing.fill_level)
                                      "
                                      class="fa-solid fa-trash-can grayC"
                                      [title]="thing.fill_level"
                                    ></i>
                                  }
                                  @if (thing.status === "Unhealthy") {
                                    <i
                                      [ngStyle]="
                                        getFillLevelStyle(thing.fill_level)
                                      "
                                      class="fa-solid fa-trash-can fa-fade grayC"
                                      [title]="thing.fill_level"
                                    ></i>
                                  }
                                  @if (
                                    thing.status === "Inactive" ||
                                    thing.status === undefined
                                  ) {
                                    <i
                                      [ngStyle]="
                                        getFillLevelStyle(thing.fill_level)
                                      "
                                      class="fa-solid fa-trash-can grayC"
                                      [title]="thing.fill_level"
                                    ></i>
                                  }
                                </div>
                                <div class="iconLabel">
                                  {{ thing.fill_level | translate }}
                                </div>
                              </div>
                              <div class="itemsColum">
                                <div class="fa-3x">
                                  <nav class="fadeIn first">
                                    <img
                                      style="height: 35px; width: 35px"
                                      class="logo"
                                      src="../assets/tonne-5123.webp"
                                    />
                                  </nav>
                                </div>
                                <div class="iconLabel">
                                  {{ thing.tonnage + " T" }}
                                </div>
                              </div>
                            </div>
                            <div class="secondRow">
                              <div class="locationLabel">
                                <i
                                  class="fa-solid fa-map-pin locationLabel"
                                ></i>
                                @if (thing.location?.trim()) {
                                  {{ thing.location }}
                                } @else {
                                  {{ "addressUnavailable" | translate }}
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </nav>
                    </article>
                  }
                </section>
              </div>
            </article>
          </section>
        </div>
      }

      @if (isZonesTabOpen) {
        <div [ngClass]="theme.getThemeClass()" id="zones" class="tab">
          <app-dispatch-zones></app-dispatch-zones>
        </div>
      }
      @if (isRoutesTabOpen) {
        <div [ngClass]="theme.getThemeClass()" id="routes" class="tab">
          @if (!loadingRoutes) {
            <!-- Routes list: summary tiles with core metadata -->
            <section class="routes-section">
              <header class="routes-header">
                <h2>{{ "Routes" | translate }} ({{ routes.length }})</h2>
              </header>
              <div class="route-tiles">
                @for (route of routes; track route.route_id) {
                  <article [ngClass]="theme.getThemeClass()" class="route-tile">
                    <div class="route-tile-header">
                      <span class="route-usage">{{
                        route.bin_usage | translate
                      }}</span>
                      <span
                        class="route-status"
                        [class.optimized]="
                          getRouteStatus(route) === 'Optimized'
                        "
                      >
                        {{ getRouteStatus(route) | translate }}
                      </span>
                      <button
                        class="route-menu-btn"
                        type="button"
                        (click)="
                          $event.stopPropagation();
                          toggleRouteMenu(route.route_id)
                        "
                      >
                        ⋮
                      </button>
                      @if (openRouteMenuId === route.route_id) {
                        <div
                          class="route-menu"
                          (click)="$event.stopPropagation()"
                        >
                          <button type="button" (click)="closeRouteMenu()">
                            {{ "Optimize Route" | translate }}
                          </button>
                          <button type="button" (click)="closeRouteMenu()">
                            {{ "Flag as Ready" | translate }}
                          </button>
                          <button
                            type="button"
                            (click)="openExportModal(route); closeRouteMenu()"
                          >
                            {{ "Export Google Map Route" | translate }}
                          </button>
                          <button
                            type="button"
                            (click)="openStops(route); closeRouteMenu()"
                          >
                            {{ "View Stops" | translate }}
                          </button>
                        </div>
                      }
                    </div>
                    <!-- Route metadata row -->
                    <div class="route-meta">
                      <div>
                        <strong>{{ "Stops" | translate }}:</strong>
                        {{ getRouteStopCount(route) }}
                      </div>
                      <div>
                        <strong>{{ "Zone" | translate }}:</strong>
                        {{ route.zone_names || "—" }}
                      </div>
                      <div>
                        <strong>{{ "Clients" | translate }}:</strong>
                        {{ route.client_names || "—" }}
                      </div>
                      <div>
                        <strong>{{ "Approx. Liters" | translate }}:</strong>
                        {{ getApproxLiters(route) }}
                      </div>
                    </div>
                  </article>
                }
              </div>
            </section>
          }
        </div>
      }
      <div style="height: 50px !important"></div>

      <ng-template #noneApplicable>
        <label>N/A</label>
      </ng-template>

      <!-- View Stops modal: grouped stops + map -->
      @if (showStopsModal) {
        <div class="modal-backdrop" (click)="closeStopsModal()"></div>
        <div class="modal large">
          <h3>{{ "View Stops" | translate }}</h3>
          <div #routeMap class="route-map"></div>
          <div class="route-stops-list">
            @for (
              stop of routeStopsGrouped;
              track stop.stop_group_key || stop.route_stop_id
            ) {
              <!-- Stop tab (grouped by GPS/address/location) -->
              <div
                class="route-stop-row"
                [class.open]="isStopOpen(stop)"
                [class.cancelled]="isStopCancelled(stop)"
              >
                <div
                  class="route-stop-header"
                  (click)="toggleStopDetails(stop)"
                >
                  <div class="route-stop-info">
                    <!-- Display reverse-geocoded address when available -->
                    <div class="route-stop-address">
                      {{ getStopDisplayAddress(stop) }}
                    </div>
                    <div
                      class="route-stop-status"
                      [class.cancelled]="isStopCancelled(stop)"
                    >
                      {{
                        getStopStatusLabel(
                          isStopCancelled(stop) ? "X" : stop.status
                        ) | translate
                      }}
                    </div>
                    @if (
                      getStopBinCount(stop) ||
                      stop.zone_names ||
                      stop.client_names
                    ) {
                      <div class="route-stop-meta">
                        <span class="route-stop-meta-item">
                          <strong>{{ "Bins" | translate }}:</strong>
                          <span class="route-stop-meta-value">{{
                            getStopBinCount(stop)
                          }}</span>
                        </span>
                        @if (stop.zone_names) {
                          <span class="route-stop-meta-item"
                            ><strong>{{ "Zone" | translate }}:</strong>
                            <span class="route-stop-meta-value">{{
                              stop.zone_names
                            }}</span></span
                          >
                        }
                        @if (stop.client_names) {
                          <span class="route-stop-meta-item"
                            ><strong>{{ "Clients" | translate }}:</strong>
                            <span class="route-stop-meta-value">{{
                              stop.client_names
                            }}</span></span
                          >
                        }
                      </div>
                    }
                  </div>
                  <!-- Stop actions (disabled if cancelled) -->
                  <div
                    class="route-stop-actions"
                    (click)="$event.stopPropagation()"
                  >
                    <button
                      class="btn"
                      type="button"
                      (click)="updateStopStatus(stop, 'C')"
                      [disabled]="isStopCancelled(stop)"
                    >
                      {{ "Complete" | translate }}
                    </button>
                    <button
                      class="btn ghost"
                      type="button"
                      (click)="updateStopStatus(stop, 'X')"
                      [disabled]="isStopCancelled(stop)"
                    >
                      {{ "Cancelled" | translate }}
                    </button>
                  </div>
                </div>
                <!-- Expanded stop details: individual devices at this stop -->
                @if (isStopOpen(stop)) {
                  <div class="route-stop-details">
                    <div class="route-stop-details-header">
                      <span>{{ "Device" | translate }}</span>
                      <span>{{ "binName" | translate }}</span>
                      <span>{{ "client" | translate }}</span>
                    </div>
                    <div class="route-stop-details-list">
                      @for (
                        detail of getStopDetailStops(stop);
                        track detail.route_stop_id || detail.bin_id
                      ) {
                        <div class="route-stop-details-row">
                          <span>{{ detail.thing_name || "—" }}</span>
                          <span>{{
                            detail.bin_name || detail.bin_id || "—"
                          }}</span>
                          <span>{{ getStopClientLabel(detail) }}</span>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
          <div class="modal-actions">
            <button class="btn" (click)="closeStopsModal()">
              {{ "Close" | translate }}
            </button>
          </div>
        </div>
      }

      @if (showExportModal) {
        <div class="modal-backdrop" (click)="closeExportModal()"></div>
        <div class="modal">
          <h3>{{ "routeExportTitle" | translate }}</h3>
          <div class="route-export-form">
            <label class="route-export-label">{{
              "routeExportStartLabel" | translate
            }}</label>
            <input
              class="input"
              type="text"
              [placeholder]="'routeExportStartPlaceholder' | translate"
              [(ngModel)]="exportStartAddress"
              #exportStartInput
            />
            @if (exportErrorKey) {
              <div class="route-export-error">
                {{ exportErrorKey | translate }}
              </div>
            }
          </div>
          @if (exportLinks.length) {
            <div class="route-export-links">
              <h4>{{ "routeExportLinksTitle" | translate }}</h4>
              <div class="route-export-list">
                @for (link of exportLinks; track $index) {
                  <a
                    class="route-export-link"
                    [href]="link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {{ "routeExportLinkLabel" | translate }} {{ $index + 1 }}
                  </a>
                }
              </div>
            </div>
          }
          <div class="modal-actions route-export-actions">
            <button
              class="btn route-export-generate"
              type="button"
              (click)="generateExportLinks()"
              [disabled]="exportLoading"
            >
              {{ "routeExportGenerate" | translate }}
            </button>
            <button class="btn" type="button" (click)="closeExportModal()">
              {{ "Close" | translate }}
            </button>
          </div>
        </div>
      }
    </div>
  </div>
}
